import { service } from '../../../helpers/http'

export const ActionIndexMenuAccessBlocks = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'index',
        payload: payload
    })
}

export const ActionStoreMenuAccessBlock = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'store',
        payload: payload
    })

}

export const ActionUpdateMenuAccessBlock = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'update',
        payload: payload
    })

}

export const ActionDestroyMenuAccessBlock = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'destroy',
        payload: payload
    })

}
